import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
    }),
  },
  methods: {
    teamCan(ability) {
      return this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account
        ? this.teams[this.$route.params.team].account.team.abilities[ability]
        : false;
    },
    teamUploadConfig(max_size = false) {
      const defConfig = {
        max_size: max_size ? max_size : 0,
      };
      return this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account
        ? this.teams[this.$route.params.team].account.team.uploads
        : defConfig;
    },
  },
};
